import { getModeledRumbles as getStoreItems } from 'selectors'
import { useSelector } from 'react-redux'

import { mapImported } from '../helpers'

const fixtures = []

export function useRumbles () {
  const imported: any[] = useSelector(getStoreItems)
  const mapped = mapImported(fixtures, imported)
  const notImported = mapped?.filter(item => item.imported === false)

  return { mapped, fixtures, notImported, imported }
}
